
import content from "!!../../../node_modules/file-loader/dist/cjs.js!./global.ftl"

let onUpdate = null
let onError = null

if (module.hot) {
  const resourcePath = "/code/frontend/src/locales/en-US/global.ftl"
  module.hot.accept(
    "!!../../../node_modules/file-loader/dist/cjs.js!./global.ftl",
    function () {
      if (onUpdate == null) {
        console.warn(`Received updated "${resourcePath}" but there's no callback registered to handle it.`)
        module.hot.invalidate()
        return
      }

      onUpdate(content)
    },
    function (err, params) {
      if (onError == null) {
        console.warn(`There was an error loading "${resourcePath}" but there's no callback registered to handle it.`)
        return
      }

      onError(err, params)
    }
  )

  module.hot.dispose(function () {
    if (onUpdate != null) {
      onUpdate(null)
    }
  })
}

export default {
  content,
  register (updateCallback, errorCallback) {
    onUpdate = updateCallback
    onError = errorCallback
  }
}
